import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { SettingsConfirmTemplate } from 'components/Templates'

const SettingsTemporaryOpenConfirm: FC = () => {
  return (
    <Layout title={'確認 | 臨時営業日の修正'}>
      <SettingsConfirmTemplate page={'open'} />
    </Layout>
  )
}

export default SettingsTemporaryOpenConfirm
